let rainEffect, snowEffect, snowCover, fogEffect, nightVisionEffect;
export default {
  components: {},
  props: {},
  data() {
    return {
      specialEffects_show: true,
      rainShow: false,
      snowShow: false,
      foggyShow: false,
      nightVisionShow: false,
      isFold: false,
    };
  },
  mounted() {
    //下雨特效。
    if (!rainEffect) {
      rainEffect = new mars3d.effect.RainEffect({
        speed: 10,
        size: 20,
        direction: -30,
      });
      rainEffect.enabled = this.rainShow;
      this.$GLOBAL.map.addEffect(rainEffect);
    }

    //下雪和积雪特效。
    if (!snowEffect) {
      snowEffect = new mars3d.effect.SnowEffect({
        speed: 20,
      });
      snowEffect.enabled = this.snowShow;
      this.$GLOBAL.map.addEffect(snowEffect);
    }
    if (!snowCover) {
      snowCover = new mars3d.effect.SnowCoverEffect({
        maxHeight: 8000, // 大于此高度后不显示
        alpha: 0.6,
      });
      snowCover.enabled = this.snowShow;
      this.$GLOBAL.map.addEffect(snowCover); //开启积雪效果
    }

    // 雾特效。
    if (!fogEffect) {
      fogEffect = new mars3d.effect.FogEffect({
        maxHeight: 20000, // 大于此高度后不显示
        fogByDistance: new Cesium.Cartesian4(100, 0.0, 9000, 0.9),
        color: Cesium.Color.WHITE,
      });
      fogEffect.enabled = this.foggyShow;
      this.$GLOBAL.map.addEffect(fogEffect);
    }

    //夜视特效。
    if (!nightVisionEffect) {
      nightVisionEffect = new mars3d.effect.NightVisionEffect();
      nightVisionEffect.enabled = this.nightVisionShow;
      this.$GLOBAL.map.addEffect(nightVisionEffect);
    }
  },
  methods: {
    specialEffectsBox_close() {
      this.$emit("specialEffectsBox_close");
    },
    rainyWeather() {
      if (this.rainShow) {
        rainEffect.enabled = true;
        this.$message({
          message: "已开启 雨天气。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      } else {
        rainEffect.enabled = false;
        this.$message({
          message: "已关闭 雨天气。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
      //this.rainShow = !this.rainShow;
    },
    snowWeather() {
      if (this.snowShow) {
        snowEffect.enabled = true;
        snowCover.enabled = true;
        this.$message({
          message: "已开启 雪天气。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      } else {
        snowEffect.enabled = false;
        snowCover.enabled = false;
        this.$message({
          message: "已关闭 雪天气。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
      //this.snowShow = !this.snowShow;
    },
    foggyWeather() {
      if (this.foggyShow) {
        fogEffect.enabled = true;
        this.$message({
          message: "已开启 雾天气。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      } else {
        fogEffect.enabled = false;
        this.$message({
          message: "已关闭 雾天气。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
      //this.foggyShow = !this.foggyShow;
    },
    nightVisionEffect() {
      if (this.nightVisionShow) {
        nightVisionEffect.enabled = true;
        this.$message({
          message: "已开启 夜视效果。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      } else {
        nightVisionEffect.enabled = false;
        this.$message({
          message: "已关闭 夜视效果。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
      //this.nightVisionShow = !this.nightVisionShow;
    },
  },
  watch: {},
  destroyed() {
    this.$GLOBAL.map.removeEffect(rainEffect, true);
    this.$GLOBAL.map.removeEffect(snowEffect, true);
    this.$GLOBAL.map.removeEffect(snowCover, true);
    this.$GLOBAL.map.removeEffect(fogEffect, true);
    this.$GLOBAL.map.removeEffect(nightVisionEffect, true);
    rainEffect = null;
    snowEffect = null;
    snowCover = null;
    fogEffect = null;
    nightVisionEffect = null;
  },
};
